export const storageKeys = {
    profile: 'profile',
    authTokenKey: 'accessToken',
    userId: 'userId',
    forgotEmail: 'forgotEmail',
    profileImage: 'profileImage',
    name: 'name'
}

export const Iconstant = {
    otpErrorMsg: 'Please Provide OTP Code',
    noDataFound: 'No records found'
}